import React, { useEffect, useState } from 'react';
import { AiModal } from '../../../../Common/fModal/AiModal';
import { post } from '../../../../../Model/Network/Config/Axios';
import _ from 'lodash';

export const AiSuggestions = ({onClose, item, systemInvoiceId,reload}) => {
  const [loading, setLoading] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const [syncing, setSyncing] = useState(false);
  const aiTdsSuggestion = item && item.aiTdsSuggestion  && _.size(item.aiTdsSuggestion)>0? item.aiTdsSuggestion : null;

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      const suggestionsList = [];
      if (aiTdsSuggestion) {
        const suggestion = {
          id: 1,
          title: 'TDS Recommendation',
          description: `Section: ${aiTdsSuggestion.recommendedTdsSection}\nRate: ${aiTdsSuggestion.recommendedTdsRate}\nReasoning: ${aiTdsSuggestion.reasoning}`,
          type: 'info'
        };
        suggestionsList.push(suggestion);
      }
      setSuggestions(suggestionsList);
    }, 400);
    
    return () => clearTimeout(timer);
  }, [item]);

  const getSync = () => {
    setSyncing(true);
    post(`/vendor/invoicing/${systemInvoiceId}/aiTdsAnalysis`, {},(e, r) => {
      if (r) {
        const items = r.itemTds.find((e => e.itemId === item.id));
        if (items) {
          const newSuggestions = [{
            id: 1,
            title: 'TDS Recommendation',
            description: `Section: ${items.recommendedTdsSection}\nRate: ${items.recommendedTdsRate}\nReasoning: ${items.reasoning}`,
            type: 'info'
          }];
          
          setSuggestions(newSuggestions);
          reload()
        }
      }
      setSyncing(false);
    });
  }

  return (
    <AiModal
      title='AI Suggestions'
      des='Dice AI-powered insights for this invoice' 
      close={onClose} 
      show={true} 
      hideButton={true}
      modalStyle={{
        maxWidth: '550px',
        borderRadius: '12px'
      }}
    >
      <div style={{ 
        padding: '10px 15px 20px', 
        borderRadius: '8px',
        minHeight: '200px'
      }}>
        {loading ? (
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            height: '200px'
          }}>
            <div style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              border: '3px solid var(--border-color)',
              borderTopColor: 'var(--primary-color)',
              animation: 'spin 1s linear infinite',
              marginBottom: '15px'
            }}></div>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
            <p style={{ color: 'var(--text-color)', fontSize: '14px' }}>Analyzing invoice data...</p>
          </div>
        ) : (
          <>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              marginBottom: '20px',
              background: 'rgba(var(--primary-color-rgb), 0.05)',
              padding: '15px',
              borderRadius: '8px'
            }}>
              <i className="fa fa-robot" style={{ 
                fontSize: '20px', 
                marginRight: '10px',
                color: 'var(--primary-color)'
              }}></i>
              <p style={{ 
                margin: 0, 
                fontSize: '14px', 
                fontWeight: '500',
                color: 'var(--text-color)'
              }}>
                {suggestions.length > 0 
                  ? 'Here are AI-powered insights for this invoice' 
                  : 'No AI insights available for this invoice'}
              </p>
            </div>

            {suggestions.length > 0 ? (
              suggestions.map(suggestion => (
                <div key={suggestion.id} style={{
                  marginBottom: '12px',
                  padding: '12px 15px',
                  borderRadius: '8px',
                  border: '1px solid var(--border-color)',
                  backgroundColor: suggestion.type === 'success' 
                    ? 'rgba(21, 205, 114, 0.05)' 
                    : suggestion.type === 'warning' 
                      ? 'rgba(255, 182, 72, 0.05)'
                      : 'rgba(var(--primary-color-rgb), 0.05)',
                  transition: 'transform 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.05)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                >
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '5px'
                  }}>
                    <i className={`fa fa-${
                      suggestion.type === 'success' ? 'check-circle' : 
                      suggestion.type === 'warning' ? 'exclamation-triangle' : 
                      'info-circle'
                    }`} style={{ 
                      fontSize: '16px', 
                      marginRight: '8px',
                      color: suggestion.type === 'success' 
                        ? '#15CD72' 
                        : suggestion.type === 'warning' 
                          ? '#FFB648'
                          : 'var(--primary-color)'
                    }}></i>
                    <h3 style={{ 
                      margin: 0, 
                      fontSize: '15px',
                      fontWeight: '600',
                      color: 'var(--text-color)'
                    }}>
                      {suggestion.title}
                    </h3>
                  </div>
                  <p style={{ 
                    margin: '0 0 0 24px', 
                    fontSize: '13px',
                    color: 'var(--light-color)',
                    whiteSpace: 'pre-line'
                  }}>
                    {suggestion.description}
                  </p>
                </div>
              ))
            ) : (
              <div style={{
                textAlign: 'center',
                padding: '20px',
                color: 'var(--light-color)'
              }}>
                No TDS information available for this invoice.
              </div>
            )}

            <div style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'center'
            }}>
              <button 
              onClick={getSync}
              disabled={syncing}
              style={{
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '8px 15px',
                fontSize: '13px',
                fontWeight: '500',
                cursor: syncing ? 'not-allowed' : 'pointer',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                opacity: syncing ? 0.7 : 1
              }}
              onMouseOver={(e) => {
                if (!syncing) {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                }
              }}
              onMouseOut={(e) => {
                if (!syncing) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.1)';
                }
              }}
              >
                {syncing ? (
                  <>
                    <div style={{
                      position: 'relative',
                      width: '20px',
                      height: '20px',
                      marginRight: '8px'
                    }}>
                      <div style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        border: '2px solid rgba(255,255,255,0.3)',
                        borderTopColor: 'white',
                        animation: 'spin 1s linear infinite'
                      }}></div>
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'white',
                        animation: 'pulse 1.5s ease-in-out infinite'
                      }}></div>
                    </div>
                    <span style={{
                      background: 'linear-gradient(90deg, #fff, #e0e0e0, #fff)',
                      backgroundSize: '200% auto',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      animation: 'shine 2s linear infinite'
                    }}>
                      AI Processing...
                    </span>
                    <style>{`
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                      @keyframes pulse {
                        0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
                        50% { transform: translate(-50%, -50%) scale(1.2); opacity: 1; }
                        100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
                      }
                      @keyframes shine {
                        0% { background-position: 0% center; }
                        100% { background-position: 200% center; }
                      }
                    `}</style>
                  </>
                ) : (
                  <>
                    <i className="fa fa-sync" style={{ fontSize: '11px' }}></i>
                    Sync AI Suggestions
                  </>
                )}
              </button>
            </div>
          </>
        )}
      </div>
    </AiModal>
  );
}